
export default {
    CheckLogout:(data) => window.axios.post('logout',data),
}